import React, { PureComponent } from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';

import { Content, Counter } from './filterModalGuests.styles';
import messages from './filterModalGuests.messages';
import { TICKET_TYPES_ORDERED, TICKET_TYPES } from '../../../../modules/booking/booking.constants';

const counterMessages = {
  [TICKET_TYPES.Adult]: messages.adults,
  [TICKET_TYPES.Child]: messages.children,
  [TICKET_TYPES.Infant]: messages.infants,
};

export class FilterModalGuests extends PureComponent {
  static propTypes = {
    setFilterDataByFilterName: PropTypes.func.isRequired,
    currentFilter: PropTypes.object.isRequired,
    setTouched: PropTypes.func.isRequired,
  };

  handleCounterUpdate = type => value => {
    const { data } = this.props.currentFilter;

    this.props.setFilterDataByFilterName(this.props.currentFilter.name, { ...data, [type]: value });
    this.props.setTouched();
  };

  renderCounters = () =>
    TICKET_TYPES_ORDERED.map((type, index) => (
      <ThemeProvider key={type} theme={{ isLast: index === TICKET_TYPES_ORDERED.length - 1 }}>
        <Counter
          message={counterMessages[type]}
          value={this.props.currentFilter.data[type]}
          onUpdate={this.handleCounterUpdate(type)}
        />
      </ThemeProvider>
    ));

  render() {
    return <Content>{this.renderCounters()}</Content>;
  }
}
